/**
 * Detect position scroll and blocks
 *
 * @returns {void} // напишу позже, если забуду
 */

const detectedScrollBlock = () => {
    let last_known_scroll_position = null;
    window.addEventListener('scroll', function(e) {
        //last_known_scroll_position = window.scrollY;
        //console.log(last_known_scroll_position)
    })
}

export default detectedScrollBlock()